module.exports = "<div class=\"loginLink natpLoginLinks\"> <div> <a href=\"https://www2.natptax.com/eweb/DynamicPage.aspx?Site=natp&WebKey=9a7aa829-1e09-4897-816d-1f261279189e\" class=\"natpLoginLink natpJoinNowLink\"> Create Account </a> </div> <div> <a href=\"https://www2.natptax.com/EWEB/DynamicPage.aspx?WebCode=forgotpassword&Site=NATP\" class=\"natpLoginLink natpForgotPasswordLink\"> Forgot Password? </a> </div> </div> <div class=natp-login-readyText></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./src/scripts/components/loginDropdown/loginFormFooter.html
// module id = 46
// module chunks = 0